
import './../../../App.css';

export default function Request_3(){
    return(
        <div className='form-header'>
            <ul>
                <li style={{backgroundColor:'#f9e0d0'}}>도면설계 - 유로폼 (거푸집)</li>
            </ul>
            <ul>
                <li>구분</li>
                <li>내용</li>
            </ul>
            <ul>
                <li>납기일</li>
                <li>
                    <label>
                        <input
                            type="date"
                            name="r3_납기일"
                            required
                        />
                    </label>
                </li>
            </ul>
            <ul>
                <li>특이사항</li>
                <li>
                    <label>
                        <textarea
                            name="r3_특이사항"
                            rows="10"
                            placeholder="특이사항을 입력해주세요"
                            style={{
                                width: '100%',
                                resize: 'vertical',
                                fontSize: '16px',
                                border: 'none',
                                fontFamily: 'Noto Sans KR, sans-serif'
                            }}
                        />
                    </label>
                </li>
            </ul>
            <input type="hidden" name="r3_구조물종류" value="유로폼 (거푸집)" />
        </div>
    )
}
